import { MissionPlanUiState } from "@/models/ui/MissionPlanUiState"
import { IMissionPlanProfilNav } from "../missionPlan/IMissionPlanProfilNav"
import { IGliderFleetFormationConfig } from "./IGliderFleetFormationConfig"
import { IMissionPlanProfilSci } from "../missionPlan/IMissionPlanProfilSci"



export interface IGliderFleetCoverageConfig extends IGliderFleetFormationConfig {	 
	prf_nav:Array<IMissionPlanProfilNav>	
}

export function getDefaultGliderFleetCoverageConfig({libelle=null as string|null,glider_type="SEAEXPLORER",battery_type="pack 18650",bms_type="neogy",payload=[] as Array<{id:number,snr_label:string}>,start_energy=29,end_battery_percent=15,prf_nav=[MissionPlanUiState.getDefaultProfil()],prf_sci=[]  as Array<IMissionPlanProfilSci>}={}) {
	return {		
		libelle,
		glider_type,		
		battery_type,
		bms_type,
		payload,
		start_energy,
		end_battery_percent,
		prf_nav,
		prf_sci
	} as IGliderFleetCoverageConfig
}